import { render, staticRenderFns } from "./CrudProduct.vue?vue&type=template&id=0caa73f2&scoped=true"
import script from "./CrudProduct.vue?vue&type=script&lang=js"
export * from "./CrudProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caa73f2",
  null
  
)

export default component.exports